import { Component, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { Sgke050dDialogComponent } from '../../components/sgke050d-dialog/sgke050d-dialog.component';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke050d',
  templateUrl: './sgke050d.component.html',
  styleUrl: './sgke050d.component.scss'
})
export class Sgke050dComponent implements OnInit, OnDestroy {
  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** 返金登録ラジオボタン */
  registType: string = '';

  /** 請求お客さま番号 */
  recptFixNo: string = '100000000000001';
  /** 未精算金管理番号 */
  kinkoMno: string = '200000000000001';
  /** 未精算金履歴番号 */
  kinkoRrkno: string = '3001';
  /** 返金管理番号 */
  repayMno: string = '400000000000001';
  /** 未精算金_更新通番号 */
  kinkoUpdateSrno: string = '50001';
  /** 未精算金EX_更新通番号 */
  kinkoexUpdatesequencenumber: string = '60001';
  /** 未精算額 */
  remny: number = 2900;


  /** ダイアログに渡すデータオブジェクト */
  dataObject = {
    kinkoMno: this.kinkoMno,
    kinkoRrkno: this.kinkoRrkno,
    repayMno: this.repayMno,
    recptFixNo: this.recptFixNo,
  };

  /** MatDialog戻り値 */
  ref: MatDialogRef<Sgke050dDialogComponent, any>;

  /**
   * コンストラクタ
   * @param {MatDialog} dialog
   * @param {ResponseMsgUtils} responseMsgUtils
   * @memberof Sgke050dComponent
   */
  constructor(
    public dialog: MatDialog,
    public responseMsgUtils: ResponseMsgUtils,
  ) { }

  /**
   * 初期処理
   * @memberof Sgke050dComponent
   */
  ngOnInit(): void {
  }
  /**
   * 購読解除
   * @memberof Sgke050dComponent
   */
  ngOnDestroy() {
  }

  /**
   * ラジオボタン押下時(sgke020dから呼ばれる再現)
   * @param {*} event
   * @memberof Sgke050dComponent
   */
  onChangeRadio(event: string): void {
    this.registType = event;
  }

  /**
   * モーダル表示(sgke090dから呼ばれる再現)
   * @memberof Sgke050dComponent
   */
  public onClickRepayInfo() {
    this.ref = this.dialog.open(Sgke050dDialogComponent, {
      height: '100',
      width: '1000px',
      disableClose: true, // 背景クリックのクローズ禁止
      data: this.dataObject // HTMLのタグ経由で値を渡す代わりに"MAT_DIALOG_DATA"にデータを詰めて渡す
    });
  }

  /**
   * sgke020d再描画再現
   * @memberof Sgke050dComponent
   */
  public search() {
    this.registType = "";
  }

  /**
 * エラーメッセージ表示
 * @memberof Sgke050dComponent
 */
  showMsg(errors) {
    // メッセージを表示
    this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(errors, this.errorMessageModelArray);
  }

  /**
    * エラーメッセージ表示領域をクリア
    * @public
    * @memberof Sgke050dComponent
    */
  public clearErrorMsg() {
    this.errorMessageModelArray.length = 0;
  }

}
